import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { SwiperSlide } from 'swiper/react';

// Components
import Slider from '../Slider';
import ReplacementSlide from './ReplacementSlide';

// Icons
import RemoveIcon from '../../icons/close.svg';

// Styles
import styles from './ReplacementSlider.styl';

const cx = classNames.bind(styles);

export default function ReplacementSlider(props) {
  const { className, replacements, removeItem, onCloseBtnClick, type, addToCart, count } = props;

  const isBonus = type === 'bonus';

  const dispatch = useDispatch();
  const addToCartHandler = (id, composition) => {
    dispatch(addToCart(id, composition));
    removeItem();
  };

  const swiperParams = {
    slidesPerView: 'auto',
    spaceBetween: 12,
  };

  return (
    <div className={cx('ReplacementSlider', className)}>
      <Slider isOutsideNavigation swiperParams={swiperParams}>
        {replacements.map((replacementItem, i) => {
          const getSlide = () => {
            if (isBonus) {
              const { sku, points, item } = replacementItem;

              return (
                <ReplacementSlide
                  addToCart={addToCartHandler}
                  key={item.id}
                  sku={sku}
                  points={points}
                  image={item.image}
                  name={item.name}
                  id={item.id}
                  type={type}
                  price={item.price}
                  count={count}
                  isBonus
                  {...item}
                />
              );
            }

            const { variations, name } = replacementItem;

            if (Array.isArray(variations)) {
              return variations.map(variation => (
                <ReplacementSlide
                  addToCart={addToCartHandler}
                  key={variations.id}
                  name={name}
                  price={variation.price}
                  id={variation.id}
                  old_price={variation?.old_price}
                  image={variation.image_cart}
                  type={type}
                  count={count}
                  {...variation}
                />
              ));
            }
            return (
              <ReplacementSlide
                addToCart={addToCartHandler}
                key={variations.id}
                name={name}
                price={variations.price}
                id={variations.id}
                old_price={variations?.old_price}
                image={variations.image_cart}
                type={type}
                count={count}
                {...variations}
              />
            );
          };

          return (
            <SwiperSlide key={i} className={cx('ReplacementSlide')}>
              {getSlide()}
            </SwiperSlide>
          );
        })}
        <SwiperSlide
          className={cx('ReplacementSlider__button-close')}
          tag="button"
          onClick={onCloseBtnClick}
        >
          <RemoveIcon width={12} height={12} />
        </SwiperSlide>
      </Slider>
    </div>
  );
}

ReplacementSlider.defaultProps = {
  className: '',
  CloseBtn: null,
  onCloseBtnClick: () => {},
};

ReplacementSlider.propTypes = {
  replacements: PropTypes.array.isRequired,
  removeItem: PropTypes.func.isRequired,
  className: PropTypes.string,
  CloseBtn: PropTypes.element,
  onCloseBtnClick: PropTypes.func,
  type: PropTypes.string.isRequired,
  addToCart: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
};
